// extracted by mini-css-extract-plugin
module.exports = {"chartCustomAxisTick":"CustomXAxisTick_chartCustomAxisTick__2bY8J"};